var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidationCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13295_64868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4687 5.84949C14.6698 5.84949 14.7889 6.08358 14.6601 6.24402L14.6591 6.24304L8.93744 13.496H8.93646C8.72554 13.7608 8.32259 13.7618 8.11224 13.496L4.90228 9.42957C4.7766 9.27017 4.89018 9.03518 5.09369 9.03503H5.91302L6.03021 9.04871C6.06872 9.05757 6.10675 9.07038 6.14252 9.08777C6.2137 9.12243 6.27614 9.17303 6.32513 9.23523L8.52338 12.0214L13.2382 6.04968C13.3372 5.92329 13.4894 5.8496 13.6494 5.84949H14.4687Z",
    fill: "#6BB030",
    stroke: "#6BB030",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19.2857C15.1284 19.2857 19.2857 15.1283 19.2857 9.99995C19.2857 4.87159 15.1284 0.714233 10 0.714233C4.87165 0.714233 0.714294 4.87159 0.714294 9.99995C0.714294 15.1283 4.87165 19.2857 10 19.2857Z",
    stroke: "#6BB030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13295_64868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationCheckCircle);
export default __webpack_public_path__ + "static/media/validation-check-circle.77d0661f7b18eece0bdb0b529ea5cd7f.svg";
export { ForwardRef as ReactComponent };